import { render, staticRenderFns } from "./repairWaiteList.vue?vue&type=template&id=388c1da3&scoped=true"
import script from "./repairWaiteList.vue?vue&type=script&lang=js"
export * from "./repairWaiteList.vue?vue&type=script&lang=js"
import style0 from "./repairWaiteList.vue?vue&type=style&index=0&id=388c1da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c1da3",
  null
  
)

export default component.exports